import { render, staticRenderFns } from "./EditarDatasMarcacao.vue?vue&type=template&id=79558d78&"
import script from "./EditarDatasMarcacao.vue?vue&type=script&lang=js&"
export * from "./EditarDatasMarcacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports